import NewDashboardModule from './newDashBoard';
import ProjectsModule from './projects';
import PipelineProjectModule from './project/pipeline';
// import ImpactAnalysisModule from './project/impact-analysis';
// import TaskManagerModule from './project/taskManager';
import { TaskManagerComponent } from './project/taskManager-ang7/taskManager.component';
import { EnvironmentTypes } from './projectWizard/environmentTypes-ang7/environmentTypes';
// import jiraCMSManagerModule from './project/jiraCMSManager';
import {JiraCmsManagerComponent} from './project/jiraCMSManager-ang7/jira-cms-manager.component'
// import { ConfigurationsViewComponent } from './project/configurationsView/configurationsView';
import EnvironmentDetailsModule from './environmentDetails';
import ProjectWizardModule from './projectWizard';
import uiRouter from 'angular-ui-router';
import CommonModule from '../common';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ImpactAnalysisComponent } from './project/impact-analysis/impact-analysis.component';
import UsersRolesManagementModule from "./usersRolesManagement";
// import HooksModule from "./project/hooks";
import { SettingComponent } from './projectWizard/settings-ang7/settings';
import {LogComponent} from './log-viewer-ang7/log-viewer.component'
import {HooksComponent} from "./project/hooks-ang7/hooks.component";
import { projectsActions } from "../../store/reducers/projectsReducer";
import { projectActions } from "../../store/reducers/projectReducer";
import { userActions } from "../../store/reducers/userReducer";
import { HtmlPageComponent } from './files/html-page/html-page.component';
// import LogViewerModule from './logViewer';
import ReportsModule from './reports';
import { CmsManagmentComponent } from './cms-management/cms-management.component';
//import { newDashboardComponent } from './newDashBoard-ang7/newDashboard';
import PolicyEngineModule from './policyEngine';
import { enumsActions } from '../../store/reducers/enumsReducer';

import { downgradeComponent } from '@angular/upgrade/static';


import { DeployedPackagesDetailsComponent } from './reports/deployed-packages-details/deployed-details-packages.component'
import { ReportsAuditComponent} from './reports/report-details-an7/reports-audit.component'
import { AboutComponent } from './about/about.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { EditModeComponent } from './edit-mode/edit-mode.component';
import { TagTypesManagerComponent } from './tag-types-manager/tag-types-manager.component';
import { LicenseDialogComponent } from '../authorized/top-bar/license-Dialog/license-dialog.component'
import { MyProfileComponent } from './my-profile/my-profile.component';
import { SubMenuComponent } from './sub-menu/sub-menu.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
// import  BackupsModule from './backups'
import {ConfigurationsViewComponent} from './project/configurationsView-ang7/configurationsView'
import  {BackupsComponent} from './buckups-ang7/backups.component'
import {AdminComponent} from "./admin/admin.component";
import {ExcludeObjectsComponent} from "@app/authorized/project/exclude-objects/exclude-objects.component";
import { StaticContentComponent } from './project/static-content/static-content.component';
import {VariablesComponent} from "@app/authorized/project/variables/variables.component";
import {VaultManagementComponent} from "@app/authorized/vault-management/vault-management.component";
import {ChatbotManagementComponent} from "@app/authorized/chatbot-management/chatbot-management.component";
import { ProjectWizardComponent } from './projectWizard/projectWizard-ang7';
import {AssignSchemasComponent} from './projectWizard/assignSchemas-ang7/assignSchemas'
import {PackageManagerComponent} from './project/packageManager/packageManager-ang7'

export default angular.module('authorized', [
    uiRouter,
    CommonModule.name,
    NewDashboardModule.name,
    ProjectsModule.name,
    PipelineProjectModule.name,
    // PackageManagerModule.name,
    //ImpactAnalysisModule.name,
    // TaskManagerModule.name,
    EnvironmentDetailsModule.name,
    ProjectWizardModule.name,
    UsersRolesManagementModule.name,
    ReportsModule.name,
    PolicyEngineModule.name
])

    .constant('PAGE_SIZE', 10) // packages component
    .directive('packageManager', downgradeComponent({ component: PackageManagerComponent }))
    .directive('sideMenu', downgradeComponent({ component: SideMenuComponent }))
    .directive('excludeObjects', downgradeComponent({ component: ExcludeObjectsComponent }))
    .directive('staticContent', downgradeComponent({ component: StaticContentComponent }))
    .directive('variables', downgradeComponent({ component: VariablesComponent }))
    .directive('envTypes', downgradeComponent({ component: EnvironmentTypes }))
    //.directive('newDashboard', downgradeComponent({ component: newDashboardComponent }))
    .directive('settings', downgradeComponent({ component: SettingComponent }))
    .directive('projectWizard', downgradeComponent({ component: ProjectWizardComponent }))
    .directive('assignSchemas', downgradeComponent({ component: AssignSchemasComponent }))
    .directive('taskManager', downgradeComponent({ component: TaskManagerComponent }))
    .directive('impactAnalysis', downgradeComponent({ component: ImpactAnalysisComponent }))
    .directive('logViewer', downgradeComponent({ component: LogComponent }))
    .directive('jiraCmsManager', downgradeComponent({ component: JiraCmsManagerComponent }))
    .directive('hooks', downgradeComponent({ component: HooksComponent }))
    .directive('subMenu', downgradeComponent({ component: SubMenuComponent }))
    .directive('backups', downgradeComponent({ component: BackupsComponent }))
    .directive('myProfile', downgradeComponent({ component: MyProfileComponent }))
    .directive('deployedPackagesDetails',downgradeComponent({ component: DeployedPackagesDetailsComponent }))
    .directive('reportsAudit',downgradeComponent({ component: ReportsAuditComponent }))
    .directive('tagTypesManager', downgradeComponent({ component: TagTypesManagerComponent }))
    .directive('licenseDialogComponent', downgradeComponent({ component: LicenseDialogComponent }))
    .directive('editMode', downgradeComponent({ component: EditModeComponent }))
    .directive('dbmAbout', downgradeComponent({ component: AboutComponent }))
    .directive('breadcrumbs', downgradeComponent({ component: BreadcrumbsComponent }))
    .directive('cmsManagment', downgradeComponent({ component: CmsManagmentComponent }))
    .directive('vaultManagment', downgradeComponent({ component: VaultManagementComponent }))
    .directive('chatbotManagment', downgradeComponent({ component: ChatbotManagementComponent }))
    .directive('admin', downgradeComponent({ component: AdminComponent }))
    .directive('topBar', downgradeComponent({ component: TopBarComponent }))
    .directive('configurationsView',downgradeComponent({ component: ConfigurationsViewComponent }))
    .run(['$rootScope', 'dynamicBrowserTitle', function ($rootScope, dynamicBrowserTitle) {
        $rootScope.$on('$stateChangeSuccess', () => {});
    }])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state({
                name: 'app.authorized',
                abstract: true,
                views: {
                    'main@app': { template: require('./authorized.tpl.html') }
                },
                resolve: {
                    globalTypes: ["store", "sessionService", (store, sessionService) => {
                        if (sessionService.user && (!store.getState().enums || (store.getState().enums && Object.keys(store.getState().enums).length < Object.keys(enumsActions).length))) {
                            store.dispatch({ type: projectActions.GET_PROJECT_ENUMS });
                        }
                    }],
                    userDetails: ["store", (store) => {
                        return store.dispatch({ type: userActions.GET_CURRENT_USER_DETAILS });
                    }],
                    isGlobalAdmin: ["store", (store) => {
                        return store.dispatch({ type: userActions.GET_CURRENT_USER_DETAILS }).then((res) => {
                            store.dispatch({ type: userActions.GET_PERMISSIONS_FOR_USER, payload: { userId: res.data.id } });
                        });
                    }]
                }
            })

            .state({
                name: 'app.authorized.projects',
                template: `<projects></projects>`,
                url: '/projects'
            })

            .state({
                name: 'app.authorized.environments',
                url: '/project/:id/pipeline/:jobId',
                template: `<pipeline></pipeline>`,
                params: {
                    name: name,
                    isNewDraft: null,
                    fromContext:false
                }
            })

            .state({
                name: 'app.authorized.configurationsView',
                url: '/project/:id/configurationsView',
                template: `<configurations-view></configurations-view>`,
                params: {
                    name: name,
                    isNewDraft: null
                }
            })
            .state({
                name: 'app.authorized.hooks',
                url: '/project/:id/hooks',
                template: '<hooks></hooks>',
                params: {
                    name: name
                }
            })
            .state({
                name: 'app.authorized.objectExclusion',
                url: '/project/:id/objectExclusion',
                template: '<exclude-objects></exclude-objects>',
                params: {
                    name: name
                }
            })
            .state({
                name: 'app.authorized.staticContent',
                url: '/project/:id/staticContent',
                template: '<static-content></static-content>',
                params: {
                    name: name
                }
            })
            .state({
                name: 'app.authorized.releaseVariable',
                url: '/project/:id/releaseVariable',
                template: '<variables></variables>',
                params: {
                    name: name
                }
            })
            .state({
                name: 'app.authorized.environment',
                abstract: true,
                url: '/project/:id/environment/:envID',
                template: `<environment-details></environment-details>`,
            })

            .state({
                name: 'app.authorized.environment.settings',
                url: '/settings',
                template: `<environment-settings></environment-settings>`,
                params: {
                    index: 'settings'
                }
            })

            .state({
                name: 'app.authorized.environment.activities',
                url: '/activities',
                template: `<environment-activities>activities</environment-activities>`,
                params: {
                    index: 'activities',
                    envName: ''
                }
            })

            .state({
                name: 'app.authorized.environment.databases',
                url: '/databases',
                template: `<environment-databases></environment-databases>`,
                params: {
                    index: 'databases'
                }
            })
            .state({
                name: 'app.authorized.environment.schemas',
                url: '/schemas',
                template: `<environment-databases></environment-databases>`,
                params: {
                    index: 'schemas'
                }
            })
            .state({
                name: 'app.authorized.environment.deployedPackages',
                url: '/deployedPackages',
                template: `<deployed-packages></deployed-packages>`,
                params: {
                    index: 'deployedPackages'
                }

            })

            .state({
                name: 'app.authorized.environment.automation',
                url: '/automation',
                template: `<automation></automation>`,
                params: {
                    index: 'automation'
                }

            })

            .state({
                name: 'app.authorized.code',
            })

            .state({
                name: 'app.authorized.packages',
                url: '/project/:id/packages',
                template: `<package-manager></package-manager>`,
                params: {
                    name: name,
                    packageName:null
                }
            })

            .state({
                name: 'app.authorized.taskManager',
                url: '/project/:id/taskManager',
                template: `<task-manager></task-manager>`,
                params: {
                    name: name
                }
            })


            .state({
                name: 'app.authorized.cmsTaskManager',
                url: '/project/:id/cmsTaskManager',
                template: `<jira-cms-manager></jira-cms-manager>`,
                params: {
                    name: name
                },
                resolve: {
                    projects: ["store", "$stateParams", (store, $stateParams) => {
                        return store.dispatch({
                            type: projectsActions.GET_PROJECT_META_DATA,
                            payload: {
                                projId: $stateParams.id
                            }
                        });

                    }]
                }
            })

            .state({
                name: 'app.authorized.project-impact-analysis',
                url: '/project/:projectId/Job/:jobId/Report/:reportId',
                template: `<impact-analysis></impact-analysis>`,
                params: {
                    projectId: null,
                    jobId: null,
                    jobType: null,
                    jobEnv: null,
                    reportId: null
                },
            })
            .state({
                name: 'app.authorized.dashboard',
                url: '/dashboard',
                template: `<new-dashboard></new-dashboard>`,
                params: {
                    projectId: null,
                    periodId: 0
                }
            })

            .state({
                name: 'app.authorized.projectWizard',
                url: '/project-wizard',
                template: '<project-wizard></project-wizard>'
            })

            .state({
                name: 'app.authorized.projectWizard.settings',
                url: '/settings/:id/:remember',
                template: '<settings (projectData)="projectData($event)"></settings>',
                params: {
                    step: 1,
                    id: '0',
                    isNew: false,
                    continued: false,
                    remember: 'new'
                }
            })

            .state({
                name: 'app.authorized.projectWizard.envTypes',
                url: '/:dbType/environmentTypes/:id',
                template: '<env-types [projectData]="vm.projectData"></env-types>',
                params: {
                       step: 2,
                       id: '0',
                       continued: false,
                        dbType: '0'
                }
            })

            .state({
                name: 'app.authorized.projectWizard.assignSchemas',
                url: '/:dbType/assignSchemas/:id',
                template: '<assign-schemas></assign-schemas>',
                params: {
                    step: 3,
                    id: '0',
                    continued: false,
                    dbType: '0'
                }
            })

            .state({
                name: 'app.authorized.fileDetails',
                url: '/files/build/job/:id/report/{labelId}/{envId}/{schemaId}',
                template: '<html-page></html-page>',
            })

            .state({
                name: 'app.authorized.validationReport',
                url: '/files/build/validation-report/:id/schema/{schemaId}',
                template: '<html-page></html-page>',
            })

            .state({
                name: 'app.authorized.logViewer',
                url: '/logViewer',
                template: '<log-viewer></log-viewer>',

            })


            .state({
                name: 'app.authorized.backups',
                url: '/project/:id/backups',
                template: '<backups></backups>',
                params:
                {
                    name: name
                }
            })


            .state({
                name: 'app.authorized.reports',
                url: '/reports',
                abstract: true,
                template: '<ui-view></ui-view>'
            })
            .state({
                name: 'app.authorized.reports.details',
                url: '/reports-details',
                template: '<reports-audit></reports-audit>'
            })
            .state({
                name: 'app.authorized.reports.summrize',
                url: '/reports-summary',
                template: '<reports-summrize></reports-summrize>'

            }).state({
                name: 'app.authorized.reports.dp',
                url: '/deployed-details-packages',
                template: '<deployed-packages-details></deployed-packages-details>'
            })
            .state({
                name: 'app.authorized.settings',
                url: '/settings',
                abstract: true,
                template: '<ui-view></ui-view>'
            })
            .state({
                name: 'app.authorized.settings.admin',
                url: '/admin',
                template: '<admin></admin>'
            })
            .state({
                name: 'app.authorized.settings.vaultManagement',
                url: '/vaultManager',
                template: '<vault-managment></vault-managment>'
            })
            .state({
                name: 'app.authorized.settings.chatbotManagement',
                url: '/chatbotManager',
                template: '<chatbot-managment></chatbot-managment>'
            })
            .state({
                name: 'app.authorized.settings.cmsManagement',
                url: '/cmsManager',
                template: '<cms-managment></cms-managment>'
            })
            .state({
                name: 'app.authorized.settings.tagTypesManager',
                url: '/tagTypesManager',
                template: '<tag-types-manager></tag-types-manager>'
            })
            .state({
                name: 'app.authorized.about',
                url: '/about',
                template: '<dbm-about></dbm-about>'
            })

            .state({
                name: 'app.authorized.myProfile',
                url: '/myProfile',
                template: '<my-profile></my-profile>'
            })
            .state({
                name: 'app.authorized.policyEngine',
                abstract: true,
                url: '/policyManager',
                template: `<policy-engine></policy-engine>`,
            })
            .state({
                name: 'app.authorized.policyEngine.rulesManagement',
                url: '/rules',
                template: `<rules-management></rules-management>`,
                params: {
                    index: 0
                }

            })
            .state({
                name: 'app.authorized.policyEngine.policyManagement',
                url: '/policies',
                template: `<policy-management>activities</policy-management>`,
                params: {
                    index: 1
                }
            })
            .state({
                name: 'app.authorized.policyEngine.policyEnforcement',
                url: '/policyEnforcement',
                template: `<policy-enforcement></policy-enforcement>`,
                params: {
                    index: 2
                }
            })

    }]);



// WEBPACK FOOTER //
// ./src/app/authorized/module.js